import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService } from "@atenea-cms";
import { SerieService, SerieFormService } from "../shared";

@Component({
  selector: "serie-form",
  templateUrl: "./serie-form.component.html",
  styleUrls: ["./serie-form.component.scss"],
})
export class SerieFormComponent implements OnInit {
  @Input() id: string;
  @Output() onSave: EventEmitter<string> = new EventEmitter();
  @Output() onDuplicate: EventEmitter<any> = new EventEmitter();
  @Output() onRemove: EventEmitter<string> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;
  form: FormGroup;

  constructor(
    public ft: FormToolsService,
    public dataService: SerieService,
    public formService: SerieFormService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.form = null;

    if (this.id) {
      this.loading = true;

      this.dataService.getById(this.id).subscribe((item) => {
        this.form = this.formService.getForm(item);
        this.loading = false;
      });
    } else {
      setTimeout(() => {
        this.form = this.formService.getForm();
      }, 100);
    }
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/series/serie-form/serie-form.component.ts